import { useNavigate } from "react-router-dom";
import "./PasswordUpdatedPage.css";
import happySittingDog from "../../../assets/progressIcon6.png";
import socialPawsLogo from "../../../assets/appIcon.svg";

const PasswordUpdatedPage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/login");
  };

  return (
    <div className="pu-page-container">
      {/* Mobile Header (Hidden on Desktop) */}
      <div
        className="fp-mobile-header fp-mobile-only"
        style={{ justifyContent: "end" }}
      >
        <div className="fp-header-logo" style={{ marginTop: "-0.5rem" }}>
          <img src={socialPawsLogo} alt="Social Paws" className="fp-logo-img" />
          <span>Social Paws</span>
        </div>
      </div>
      {/* Main Content */}
      <div className="pu-content-wrapper">
        {/* Mascot Icon */}
        <div className="pu-mascot-container">
          <img src={happySittingDog} alt="Happy Sitting Dog" />
        </div>

        <h1 className="pu-title">Password Updated!</h1>

        <p className="pu-subtitle">
          Use your new password to sign in to your account
        </p>

        {/* Continue Button */}
        <button className="pu-continue-btn" onClick={handleContinue}>
          CONTINUE
        </button>

        <div className="pu-signup-link">
          Don't have an account?{" "}
          <span onClick={() => navigate("/onboarding")}>Sign Up Here</span>
        </div>
      </div>
    </div>
  );
};

export default PasswordUpdatedPage;
